import { render } from "./channelManage.vue?vue&type=template&id=75a653a7"
import script from "./channelManage.vue?vue&type=script&setup=true&lang=js"
export * from "./channelManage.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/exhibitionManage/channelManage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "75a653a7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75a653a7', __exports__)) {
    console.log('reload')
    api.reload('75a653a7', __exports__)
  }
  
  module.hot.accept("./channelManage.vue?vue&type=template&id=75a653a7", () => {
    console.log('re-render')
    api.rerender('75a653a7', render)
  })

}


export default __exports__